module.exports = __webpack_public_path__ + "assets/img/6_493_big.14cc45f5.jpg";